
// Social Media Data
export const socialMediaData = {
  competitors: [
    { id: 1, name: "Your Company", color: "#6366f1" },
    { id: 2, name: "Competitor A", color: "#f43f5e" },
    { id: 3, name: "Competitor B", color: "#10b981" },
    { id: 4, name: "Competitor C", color: "#f97316" }
  ],
  postFrequency: [
    { date: "2023-01", "Your Company": 15, "Competitor A": 22, "Competitor B": 18, "Competitor C": 12 },
    { date: "2023-02", "Your Company": 18, "Competitor A": 20, "Competitor B": 16, "Competitor C": 14 },
    { date: "2023-03", "Your Company": 21, "Competitor A": 19, "Competitor B": 20, "Competitor C": 11 },
    { date: "2023-04", "Your Company": 19, "Competitor A": 24, "Competitor B": 17, "Competitor C": 13 },
    { date: "2023-05", "Your Company": 22, "Competitor A": 23, "Competitor B": 19, "Competitor C": 15 },
    { date: "2023-06", "Your Company": 25, "Competitor A": 21, "Competitor B": 22, "Competitor C": 14 }
  ],
  engagementRankings: [
    { 
      company: "Your Company", 
      postsPerWeek: 4.5, 
      avgLikes: 320, 
      avgComments: 45, 
      avgShares: 28 
    },
    { 
      company: "Competitor A", 
      postsPerWeek: 6.2, 
      avgLikes: 450, 
      avgComments: 62, 
      avgShares: 41 
    },
    { 
      company: "Competitor B", 
      postsPerWeek: 5.1, 
      avgLikes: 380, 
      avgComments: 53, 
      avgShares: 32 
    },
    { 
      company: "Competitor C", 
      postsPerWeek: 3.8, 
      avgLikes: 290, 
      avgComments: 38, 
      avgShares: 24 
    }
  ],
  postTypes: [
    { 
      company: "Your Company", 
      text: 25, 
      image: 40, 
      video: 20, 
      link: 15 
    },
    { 
      company: "Competitor A", 
      text: 15, 
      image: 35, 
      video: 40, 
      link: 10 
    },
    { 
      company: "Competitor B", 
      text: 30, 
      image: 30, 
      video: 25, 
      link: 15 
    },
    { 
      company: "Competitor C", 
      text: 35, 
      image: 25, 
      video: 15, 
      link: 25 
    }
  ],
  platforms: [
    {
      platform: "LinkedIn",
      "Your Company": 42,
      "Competitor A": 56,
      "Competitor B": 39,
      "Competitor C": 28
    },
    {
      platform: "Instagram",
      "Your Company": 35,
      "Competitor A": 48,
      "Competitor B": 52,
      "Competitor C": 31
    },
    {
      platform: "YouTube",
      "Your Company": 18,
      "Competitor A": 32,
      "Competitor B": 24,
      "Competitor C": 15
    },
    {
      platform: "TikTok",
      "Your Company": 22,
      "Competitor A": 40,
      "Competitor B": 30,
      "Competitor C": 18
    }
  ]
};

// Market Sentiment Data
export const marketSentimentData = {
  competitors: [
    { id: 1, name: "Your Company" },
    { id: 2, name: "Competitor A" },
    { id: 3, name: "Competitor B" },
    { id: 4, name: "Competitor C" }
  ],
  reviews: [
    {
      company: "Your Company",
      source: "Google Reviews",
      rating: 4.2,
      sentiment: { positive: 78, neutral: 12, negative: 10 },
      pros: ["Great customer service", "Reliable products", "Good value"],
      cons: ["Limited features", "Slow response times"]
    },
    {
      company: "Competitor A",
      source: "Google Reviews",
      rating: 4.5,
      sentiment: { positive: 82, neutral: 10, negative: 8 },
      pros: ["Innovative features", "Fast service", "User-friendly"],
      cons: ["Expensive", "Limited integrations"]
    },
    {
      company: "Competitor B",
      source: "Google Reviews",
      rating: 3.9,
      sentiment: { positive: 65, neutral: 15, negative: 20 },
      pros: ["Affordable", "Basic features work well"],
      cons: ["Buggy software", "Poor customer support"]
    },
    {
      company: "Competitor C",
      source: "Google Reviews",
      rating: 4.0,
      sentiment: { positive: 70, neutral: 20, negative: 10 },
      pros: ["Good value", "Stable platform"],
      cons: ["Outdated UI", "Limited features"]
    },
    // Glassdoor Reviews
    {
      company: "Your Company",
      source: "Glassdoor",
      rating: 3.8,
      sentiment: { positive: 70, neutral: 15, negative: 15 },
      pros: ["Good work-life balance", "Collaborative environment"],
      cons: ["Limited growth opportunities", "Below market pay"]
    },
    {
      company: "Competitor A",
      source: "Glassdoor",
      rating: 4.1,
      sentiment: { positive: 75, neutral: 15, negative: 10 },
      pros: ["Innovative culture", "Competitive compensation"],
      cons: ["High pressure", "Long hours"]
    }
  ]
};

// Event Tracker Data
export const eventTrackerData = [
  {
    company: "Your Company",
    events: [
      { 
        type: "Trade Show", 
        name: "MarketExpo 2023", 
        date: "2023-03-15", 
        description: "Showcasing new product line" 
      },
      { 
        type: "Webinar", 
        name: "Customer Success Story", 
        date: "2023-04-22", 
        description: "Case study with major client" 
      }
    ]
  },
  {
    company: "Competitor A",
    events: [
      { 
        type: "Product Launch", 
        name: "NextGen Platform", 
        date: "2023-02-10", 
        description: "Launch of new software platform" 
      },
      { 
        type: "Conference", 
        name: "TechCon 2023", 
        date: "2023-05-18", 
        description: "Keynote speaker on innovation" 
      },
      { 
        type: "Webinar", 
        name: "Industry Trends", 
        date: "2023-06-05", 
        description: "Analysis of market direction" 
      }
    ]
  },
  {
    company: "Competitor B",
    events: [
      { 
        type: "Office Opening", 
        name: "New Headquarters", 
        date: "2023-04-02", 
        description: "Opening ceremony for new location" 
      },
      { 
        type: "Webinar", 
        name: "Product Tutorial", 
        date: "2023-05-12", 
        description: "Demonstration of new features" 
      }
    ]
  },
  {
    company: "Competitor C",
    events: [
      { 
        type: "Trade Show", 
        name: "IndustryExpo", 
        date: "2023-03-28", 
        description: "Booth with demos and presentations" 
      },
      { 
        type: "Seminar", 
        name: "Best Practices", 
        date: "2023-06-15", 
        description: "Educational session for prospects" 
      }
    ]
  }
];

// Job & Hiring Data
export const jobHiringData = {
  trends: [
    { month: "Jan", "Your Company": 5, "Competitor A": 12, "Competitor B": 8, "Competitor C": 3 },
    { month: "Feb", "Your Company": 7, "Competitor A": 10, "Competitor B": 6, "Competitor C": 4 },
    { month: "Mar", "Your Company": 8, "Competitor A": 15, "Competitor B": 9, "Competitor C": 5 },
    { month: "Apr", "Your Company": 10, "Competitor A": 14, "Competitor B": 7, "Competitor C": 8 },
    { month: "May", "Your Company": 12, "Competitor A": 18, "Competitor B": 10, "Competitor C": 6 },
    { month: "Jun", "Your Company": 15, "Competitor A": 16, "Competitor B": 12, "Competitor C": 7 }
  ],
  recentJobs: [
    {
      company: "Your Company",
      jobs: [
        { title: "Marketing Specialist", location: "New York", date: "2023-06-01" },
        { title: "Product Manager", location: "Remote", date: "2023-05-28" },
        { title: "UX Designer", location: "San Francisco", date: "2023-05-15" }
      ]
    },
    {
      company: "Competitor A",
      jobs: [
        { title: "Senior Developer", location: "Boston", date: "2023-06-10" },
        { title: "Marketing Director", location: "Chicago", date: "2023-06-05" },
        { title: "Sales Executive", location: "Austin", date: "2023-05-22" },
        { title: "Data Analyst", location: "Remote", date: "2023-05-18" }
      ]
    },
    {
      company: "Competitor B",
      jobs: [
        { title: "Customer Success Manager", location: "Seattle", date: "2023-06-08" },
        { title: "Product Designer", location: "Los Angeles", date: "2023-05-25" },
        { title: "Content Strategist", location: "Denver", date: "2023-05-20" }
      ]
    },
    {
      company: "Competitor C",
      jobs: [
        { title: "Frontend Developer", location: "Portland", date: "2023-06-02" },
        { title: "Account Executive", location: "Atlanta", date: "2023-05-30" }
      ]
    }
  ]
};

// Messaging & Positioning Data
export const messagingData = {
  keyThemes: [
    {
      company: "Your Company",
      themes: [
        { theme: "Reliability", frequency: 85 },
        { theme: "Customer-centric", frequency: 72 },
        { theme: "Value", frequency: 68 },
        { theme: "Innovation", frequency: 45 }
      ]
    },
    {
      company: "Competitor A",
      themes: [
        { theme: "Innovation", frequency: 92 },
        { theme: "Enterprise-grade", frequency: 78 },
        { theme: "AI-powered", frequency: 70 },
        { theme: "Security", frequency: 65 }
      ]
    },
    {
      company: "Competitor B",
      themes: [
        { theme: "Affordability", frequency: 88 },
        { theme: "Simplicity", frequency: 75 },
        { theme: "Scalability", frequency: 60 },
        { theme: "Support", frequency: 55 }
      ]
    },
    {
      company: "Competitor C",
      themes: [
        { theme: "Experience", frequency: 80 },
        { theme: "Stability", frequency: 75 },
        { theme: "Integration", frequency: 65 },
        { theme: "Global reach", frequency: 50 }
      ]
    }
  ],
  positioningChanges: [
    {
      company: "Your Company",
      periods: [
        { period: "Q1", theme: "Reliability", emphasis: 80 },
        { period: "Q2", theme: "Reliability", emphasis: 75 },
        { period: "Q3", theme: "Customer-centric", emphasis: 85 },
        { period: "Q4", theme: "Value", emphasis: 90 }
      ]
    },
    {
      company: "Competitor A",
      periods: [
        { period: "Q1", theme: "Innovation", emphasis: 85 },
        { period: "Q2", theme: "Innovation", emphasis: 90 },
        { period: "Q3", theme: "AI-powered", emphasis: 95 },
        { period: "Q4", theme: "Enterprise-grade", emphasis: 88 }
      ]
    }
  ]
};

// Product Launch Tracker
export const productLaunchData = [
  {
    company: "Your Company",
    launches: [
      {
        name: "Product Suite 2.0",
        date: "2023-03-15",
        messaging: "Enhanced user experience with new features",
        audience: "Enterprise clients",
        positioning: "Productivity improvement"
      },
      {
        name: "Mobile App Redesign",
        date: "2023-05-20",
        messaging: "Seamless experience across devices",
        audience: "All customers",
        positioning: "Convenience and accessibility"
      }
    ]
  },
  {
    company: "Competitor A",
    launches: [
      {
        name: "AI Assistant Pro",
        date: "2023-02-10",
        messaging: "Revolutionary AI-driven productivity",
        audience: "Large enterprises",
        positioning: "Cutting-edge technology leader"
      },
      {
        name: "Data Analytics Platform",
        date: "2023-06-05",
        messaging: "Unlock insights from your data",
        audience: "Data-focused companies",
        positioning: "Advanced analytics for everyone"
      }
    ]
  },
  {
    company: "Competitor B",
    launches: [
      {
        name: "Budget Solution",
        date: "2023-04-12",
        messaging: "Affordable solution with essential features",
        audience: "Small businesses",
        positioning: "Best value in the market"
      }
    ]
  },
  {
    company: "Competitor C",
    launches: [
      {
        name: "Enterprise Hub",
        date: "2023-01-25",
        messaging: "Centralized management for complex organizations",
        audience: "Enterprise & government",
        positioning: "Stability and control"
      },
      {
        name: "Collaboration Tool",
        date: "2023-05-30",
        messaging: "Work together seamlessly",
        audience: "Teams of all sizes",
        positioning: "Enhanced teamwork"
      }
    ]
  }
];

// Partnerships & Success Stories
export const partnershipData = [
  {
    company: "Your Company",
    partnerships: [
      {
        partner: "TechCorp Inc.",
        type: "Technology Integration",
        announcement: "2023-04-02",
        description: "Strategic integration to enhance product capabilities",
        industry: "Technology",
        region: "North America"
      },
      {
        partner: "Global Services Ltd",
        type: "Distribution Agreement",
        announcement: "2023-06-10",
        description: "Expanding market reach across EMEA region",
        industry: "Professional Services",
        region: "EMEA"
      }
    ]
  },
  {
    company: "Competitor A",
    partnerships: [
      {
        partner: "Big Retailer",
        type: "Implementation",
        announcement: "2023-03-15",
        description: "Successful deployment across 500+ locations",
        industry: "Retail",
        region: "Global"
      },
      {
        partner: "Finance Solutions",
        type: "Joint Venture",
        announcement: "2023-05-22",
        description: "New financial technology platform",
        industry: "Financial Services",
        region: "North America"
      }
    ]
  },
  {
    company: "Competitor B",
    partnerships: [
      {
        partner: "MediCompany",
        type: "Case Study",
        announcement: "2023-02-18",
        description: "30% improvement in operational efficiency",
        industry: "Healthcare",
        region: "Europe"
      }
    ]
  },
  {
    company: "Competitor C",
    partnerships: [
      {
        partner: "Government Agency",
        type: "Contract",
        announcement: "2023-04-28",
        description: "5-year service agreement for platform implementation",
        industry: "Government",
        region: "Asia Pacific"
      },
      {
        partner: "Educational Network",
        type: "Program Partnership",
        announcement: "2023-06-05",
        description: "Supporting digital transformation in education",
        industry: "Education",
        region: "Global"
      }
    ]
  }
];

// Subscription plans
export const subscriptionPlans = [
  {
    id: 'basic',
    name: 'Basic',
    description: 'For individuals and small teams starting out with competitive analysis',
    price: 29,
    features: [
      'Up to 3 competitors',
      'Basic social media metrics',
      'Weekly report updates',
      'Limited historical data (3 months)',
      '1 user account'
    ],
    modules: [
      'Social Media Activity Tracker',
      'Engagement Rankings Table'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'For growing teams that need deeper competitive insights',
    price: 79,
    popular: true,
    features: [
      'Up to 8 competitors',
      'Comprehensive social media metrics',
      'Daily report updates',
      'Extended historical data (12 months)',
      'Up to 5 user accounts',
      'Custom dashboard layouts'
    ],
    modules: [
      'Social Media Activity Tracker',
      'Engagement Rankings Table',
      'Market Sentiment Aggregator',
      'Event Tracker',
      'Job & Hiring Monitor'
    ]
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'For organizations requiring the most extensive competitive intelligence',
    price: 199,
    features: [
      'Unlimited competitors',
      'Advanced analytics and custom metrics',
      'Real-time updates',
      'Complete historical data',
      'Unlimited user accounts',
      'Priority support',
      'Custom integrations'
    ],
    modules: [
      'All modules included',
      'API access',
      'Custom reports',
      'Advanced filtering',
      'Export functionality'
    ]
  }
];

// Users (mock data)
export const users = [
  {
    id: 1,
    email: 'demo@example.com',
    password: 'demo123', // In a real app, NEVER store passwords in plain text
    name: 'Demo User',
    company: 'Marketing Inc.',
    subscription: 'professional',
    dashboardConfig: {
      layout: 'grid',
      modules: [
        { id: 'social-media', position: 0, enabled: true },
        { id: 'engagement', position: 1, enabled: true },
        { id: 'sentiment', position: 2, enabled: true },
        { id: 'events', position: 3, enabled: true },
        { id: 'hiring', position: 4, enabled: true }
      ]
    }
  }
];
